module.exports = __webpack_public_path__ + "img/si.cab53f91.svg";